import panguInputNumber from './input-number.vue'
export default panguInputNumber
